<template lang="pug">
  div
    float-btn.btn-success.clickable(@click='openCreateEventModal')
      i.fa.fa-plus
      .title {{$t('events.createModal.title')}}
    float-btn.btn-info
      i.fa.fa-ellipsis-h
      a.btn.btn-danger.clickable(@click='openConfigurationModal')
        i.fa.fa-cog
        .title {{$t('globals.configure')}}
      a.btn.btn-primary.clickable(@click='asCalendar', v-if='isListView')
        i.fa.fa-calendar
        .title {{$t('events.fixedBtn.calendarView')}}
      a.btn.btn-warning.clickable(@click='asMonth', v-if='!isListView')
        | {{$t('events.fixedBtn.monthView.letter')}}
        .title {{$t('events.fixedBtn.monthView.label')}}
      a.btn.btn-warning.clickable(@click='asWeek', v-if='!isListView')
        | {{$t('events.fixedBtn.weekView.letter')}}
        .title {{$t('events.fixedBtn.weekView.label')}}
      a.btn.btn-warning.clickable(@click='asDay', v-if='!isListView')
        | {{$t('events.fixedBtn.dayView.letter')}}
        .title {{$t('events.fixedBtn.dayView.label')}}
      a.btn.btn-primary.clickable(@click='asList', v-if='!isListView')
        i.fa.fa-list
        .title {{$t('events.fixedBtn.listView')}}
    events-calendar(v-if='!isListView', :view='view', :eventsBus='eventsBus')
    events-list(v-if='isListView', :injected='injected', :eventsBus='eventsBus')
    events-configuration-modal(:eventsBus='eventsBus')
</template>
<script>
import {mapGetters} from 'vuex'

import modalsBus from '@/components/shared/ModalsBus'
import eventsBus from '@/components/shared/EventsBus'

import FloatBtn from '@/components/shared/FloatBtn'
import EventsCalendar from './Events-Calendar'
import EventsList from './Events-List'
import EventsCreateEventModal from './Events-CreateEventModal'
import EventsImportICSModal from './Events-ImportICSModal'

import Proposition from '@/components/shared/Proposition'

import MousetrapManager from '@/components/shared/mousetrapManager'

import EventsConfigurationModal from '@/components/Events/Events-ConfigurationModal'

let VIEWS = {
  LIST: 'list',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day'
}
export default {
  data () {
    return {
      view: localStorage.getItem('calendar-view') || VIEWS.MONTH,
      injected: false,
      eventsBus: eventsBus
    }
  },
  components: {
    FloatBtn,
    EventsCalendar,
    EventsList,
    EventsCreateEventModal,
    EventsImportICSModal,
    EventsConfigurationModal
  },
  computed: {
    ...mapGetters('groops', [
      'selectedGroops'
    ]),
    ...mapGetters('search', [
      'searchObject',
      'searchOpen'
    ]),
    isListView () {
      return this.view === VIEWS.LIST
    }
  },
  mounted () {
    let thisVue = this
    this.$synchronize.addSyncItem('eventsUpdate', {
      parameters () {
        this.vue = thisVue
        return {}
        // this.currentNode = thisVue.currentNode
        // return {
        //   group: this.currentNode.group.id,
        //   folder: this.currentNode.id
        // }
      },
      failCallback (data) {
        console.error(data)
      },
      callback (data) {
        // console.log(data)
        // this.$set(group, 'storageSize', data.storageSize)
        // this.$set(group, 'storageMax', data.storageMax)
        // this.$set(group, 'storageEnd', data.storageEnd)
        // if (this.currentNode.nodes != null) {
        //   return (() => {
        //     const result = []
        //     for (var node of Array.from(data.updates)) {
        //       const index = _.findIndex(this.currentNode.nodes, x => (x.id === node.id) && (x.kind === node.kind))
        //       if (index === -1) {
        //         result.push(this.currentNode.nodes.push(node))
        //       } else {
        //         result.push(this.$set(this.currentNode.nodes, index, node))
        //       }
        //     }
        //     return result
        //   })()
        // }
      },
      interval: 5000
    }
    )
    MousetrapManager.bindAll({
      'c': (e) => {
        // prevent to have a 'c' in input
        e.preventDefault()
        this.openCreateEventModal()
      },
      'd': () => { this.asDay() },
      'w': () => { this.asWeek() },
      'm': () => { this.asMonth() },
      'l': () => { this.asList() }
    }, 'Events')
    this.updateOnAppwire = (data) => {
      console.log(data)
      eventsBus.$emit(eventsBus.UPDATED_EVENT, {})
    }
    this.$appwireEvents.$on('calendar', this.updateOnAppwire)
  },
  destroyed () {
    MousetrapManager.unbindLabel('Events')
    this.$synchronize.removeSyncItem('eventsUpdate')
    this.$store.dispatch('search/setNewText', '')
    this.$appwireEvents.$off('calendar', this.updateOnAppwire)
  },
  methods: {
    asCalendar () {
      this.view = localStorage.getItem('calendar-view-calendar') || VIEWS.MONTH
    },
    asList () {
      this.view = VIEWS.LIST
    },
    asDay () {
      this.view = VIEWS.DAY
    },
    asWeek () {
      this.view = VIEWS.WEEK
    },
    asMonth () {
      this.view = VIEWS.MONTH
    },
    openCreateEventModal () {
      return modalsBus.open(modalsBus.modals.CREATE_EVENT)
    },
    openConfigurationModal () {
      return modalsBus.open(modalsBus.modals.CONFIGURE_CALENDAR)
    },
    sendSearchPropositions () {
      let propositions = []
      if (!this.searchOpen) {
        this.$store.dispatch('search/setPropositions', propositions)
        return
      }
      if (this.searchObject.inEntry) {
        if (this.searchObject.lastToken === 'answer:') {
          propositions.push(new Proposition('none', {
            textToShow: 'answer: none',
            explanationKey: 'noneAnswer'
          }))
          propositions.push(new Proposition('yes', {
            textToShow: 'answer: yes',
            explanationKey: 'answerYes'
          }))
          propositions.push(new Proposition('no', {
            textToShow: 'answer: no',
            explanationKey: 'answerNo'
          }))
          propositions.push(new Proposition('maybe', {
            textToShow: 'answer: maybe',
            explanationKey: 'answerMaybe'
          }))
          propositions.push(new Proposition('yes answer: maybe answer: none', {
            textToShow: 'answer: yes answer: maybe answer: none',
            explanationKey: 'answerNotNo'
          }))
        }
      } else {
        if (!this.searchObject.answers || this.searchObject.answers.length === 0) {
          if (this.searchObject.lastToken === '' || 'answer:'.indexOf(this.searchObject.lastToken) === 0) {
            propositions.push(new Proposition('answer:', {
              textToShow: 'answer: ...',
              textToRemove: this.searchObject.lastToken,
              explanationKey: 'keyword_answer'
            }))
          }
        }
      }
      this.$store.dispatch('search/setPropositions', propositions)
    }
  },
  watch: {
    selectedGroops () {
      this.lastTimeChange = this.lastTimeChange + 1
    },
    view () {
      if (!this.isListView) {
        localStorage.setItem('calendar-view-calendar', this.view)
      }
      localStorage.setItem('calendar-view', this.view)
    },
    searchObject () {
      this.sendSearchPropositions()
    },
    searchOpen () {
      this.sendSearchPropositions()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Events.vue?29b33c74